module.exports = __webpack_public_path__ + "img/026  Chemistry-Solid.0a0a720e.svg";